import React, { useCallback, useState } from "react";
import Container from "react-bootstrap/Container";
import CreateBatchAssignationForm from "./CreateBatchAssignationForm";
import InfoModalContent from '../Layout/InfoModalContent';

const CreateBatchAssignation = ({
    infoModalData,
    setInfoModalData,
    handleFileUpload,
    uploading,
}) => {
    const [file, setFile] = useState(null);

    const handleSubmit = useCallback(
        (event) => {
            event.preventDefault();
            handleFileUpload(file.files[0]);
        },
        [handleFileUpload, file]
    );

    return (
        <Container fluid>
            {infoModalData && infoModalData.show
            ? <div className="text-center w-50 m-auto">
                <InfoModalContent
                    type={infoModalData.type}
                    closeButton={infoModalData.closeButton}
                    retryButton={infoModalData.retryButton}
                    msg={infoModalData.msg}
                    setMsg={setInfoModalData}
                    ok={infoModalData.ok}
                    cancel={infoModalData.cancel}
                />
            </div>
            : <div>
                <CreateBatchAssignationForm
                validated={false}
                handleSubmit={handleSubmit}
                file={file}
                setFile={setFile}
                uploading={uploading}
            /></div>
            }
        </Container>
    );
};

export default CreateBatchAssignation;
